module.exports = __webpack_public_path__ + "img/fail3.ad75b015.gif";